@if(getEnvTag != undefined && getEnvTag.tag != 'prod') {
    <span class="env-tag" [style.background-color]="getEnvTag.color">
        {{getEnvTag.tag}}
    </span>     
}